// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import { Rate } from "element-ui";
import { Toast } from "mint-ui";
import VueWechatTitle from "vue-wechat-title";

Vue.use(VueWechatTitle);

Vue.component(Toast.name, Toast);

Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.innerText;
    el.remove();
  }
});

Vue.prototype.$axios = axios;

axios.defaults.timeout = 10000;

// axios.defaults.baseURL = "https://data.wax-apple.cn/"; // 测试环境域名
axios.defaults.baseURL = "https://data.wax-apple.cn/"; // 线上环境域名

// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    Toast("网络繁忙，请稍后再试！");
    // Do something with response error
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;
Vue.use(Rate);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js